/* eslint-disable eqeqeq */
import React from 'react'

const Select = (props) => {
  return (
    <div className='profile-input-box box-shadow'>
      <div>{props.icon}</div>
      <div className='w-100 h-100'>
        <select
          onChange={(event) => props.OnClick(event)}
          name={props.name}
          value={props.value != undefined && props.value ? props.value : ''}
        >
          <option value='' disabled selected>
            {props.title}
          </option>
          {props.data != undefined &&
            props.data.map((option) => (
              <option value={option._id}>{option.title}</option>
            ))}
        </select>
      </div>
    </div>
  )
}
export default Select
